<script>
    import { setContext } from "svelte";
    import { flip } from "svelte/animate";

    import Toast from "./Toast.svelte";

    import { TOASTS_KEY } from "./toast.js";

    export let position;

    $: positionClass = (() => {
        const valid = [
            "top",
            "top-left",
            "top-right",
            "bottom",
            "bottom-left",
            "bottom-right",
            "left",
            "right",
        ].includes(position);

        if (valid) {
            return position;
        } else {
            return "bottom";
        }
    })();

    setContext(TOASTS_KEY, {
        addToast: (toast) => addToast(toast),
        removeToast: (id) => removeToast(id),
        getToasts: () => toasts,
    });

    let toasts = [];
    let idCounter = 0;

    function addToast(toast) {
        toast.id = idCounter;
        idCounter += 1;
        toasts = [toast, ...toasts];
        return toast;
    }

    function removeToast(id) {
        toasts = toasts.filter((it) => it.id !== id);
    }
</script>

<slot />

<div class={`container ${positionClass}`}>
    {#each toasts as toast (toast.id)}
        <div class="toast" animate:flip={{ duration: 250 }}>
            <Toast {toast} />
        </div>
    {/each}
</div>

<style>
    .container {
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .container.bottom {
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        align-items: center;
    }

    .container.bottom-left {
        bottom: 0px;
        left: 5px;
        align-items: flex-start;
    }

    .container.bottom-right {
        bottom: 0px;
        right: 5px;
        align-items: flex-end;
    }

    .container.top {
        top: 5px;
        left: 50%;
        transform: translateX(-50%);
        align-items: center;
    }

    .container.top-left {
        top: 5px;
        left: 5px;
        align-items: flex-start;
    }

    .container.top-right {
        top: 5px;
        right: 5px;
        align-items: flex-end;
    }

    .container.left {
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        align-items: flex-start;
    }

    .container.right {
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        align-items: flex-end;
    }

    .toast {
        margin-bottom: 5px;
    }
</style>
